import { Link } from 'react-router-dom';
import { FACEBOOK, INSTAGRAM } from '../assets/icons';
import  NAV_LOGO  from '../assets/logos/World_O_Tutor.png';
import { useAppSelector } from '../hooks/useRedux';

export default function Footer() {
  const { profile } = useAppSelector(state => state.profileSlice);

  return (
    <div className='w-full bg-neutralBlack'>
      <div className="flex lg:flex-row flex-col bg-neutralBlack container mx-auto py-10">
        <div className="lg:flex-1 lg:basis-1/3 w-full">
          <div className="mb-5">
            <img src={NAV_LOGO} alt="world o tutor logo" className='max-w-44' />
          </div>
          <div>
            <p className="text-sm font-normal text-white lg:w-4/5 w-full leading-loose">
              India’s largest online platform where thousands of students and teachers across the globe participate in
              an effective educational exchange.
            </p>
          </div>
        </div>
        <div className="lg:flex lg:flex-1 lg:basis-3/4 grid grid-cols-2 grid-rows-2 lg:mt-0 mt-5 justify-between">
          <div className="flex flex-col gap-y-4">
            <span className="text-xl font-medium text-white">For student</span>
            <Link to={`${process.env.REACT_APP_STUDENT_DOMAIN!}/find-tutor`}>
              <span className="text-sm font-normal text-white">Find a tutor</span>
            </Link>
            <Link to={`${process.env.REACT_APP_STUDENT_DOMAIN!}/explore/subject`}>
              <span className="text-sm font-normal text-white">Explore</span>
            </Link>
            {/* <Link to={`${process.env.REACT_APP_STUDENT_DOMAIN!}/login`}>
              <span className="text-sm font-normal text-white">Login as student</span>
            </Link> */}
          </div>
          <div className="flex flex-col gap-y-4">
            <span className="text-xl font-medium text-white">For tutors</span>
            <Link to={process.env.REACT_APP_TUTOR_DOMAIN!}>
              <span className="text-sm font-normal text-white">Join as tutor</span>
            </Link>
            {!profile &&
              <Link to={`/login`}>
                <span className="text-sm font-normal text-white">Login as tutor</span>
              </Link>
            }
          </div>
          <div className="flex flex-col gap-y-4 lg:mt-0 mt-3">
            <span className="text-xl font-medium text-white">Resources</span>
            {/* <Link to={"/about"}>
              <span className="text-sm font-normal text-white">About Us</span>
            </Link>
            <Link to={"/contact"}>
              <span className="text-sm font-normal text-white">Contact Us</span>
            </Link> */}
            <Link to={"/legal/terms-conditions"}>
              <span className="text-sm font-normal text-white">Terms And Conditions</span>
            </Link>

          </div>
          <div className="flex flex-col gap-y-4 lg:items-center items-start lg:mt-0 mt-3">
            <span className="text-xl font-medium text-white">Follow Us</span>
            <div className="flex gap-5">
              <img src={FACEBOOK} alt="Facebook logo" />
              <img src={INSTAGRAM} alt="Instagram logo" />
            </div>
          </div>
        </div>
      </div>
      <div className="w-11/12 mx-auto bg-neutralBlack py-5">
        <footer className="border-t-2 border-white py-4">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="text-center lg:text-start  w-min">
              <p className="text-white font-normal whitespace-nowrap">
                &copy; <strong>2023 All rights reserved</strong>
              </p>
            </div>
            <div className="flex-1 px-4 md:flex grid grid-cols-2 grid-rows-2 text-center lg:pt-0 pt-2 lg:w-4/5 w-full justify-center">
              <Link to="/testimonials" className="py-2 px-4 text-white text-sm hover:underline">
                Testimonials
              </Link>
              <Link to="/legal/terms-conditions" className="py-2 px-4 text-white text-sm hover:underline">
                Terms of Service
              </Link>
              <Link to="/legal/privacy-policy" className="py-2 px-4 text-white text-sm hover:underline">
                Privacy Policy
              </Link>
              <Link to="#" className="py-2 px-4 text-white text-sm hover:underline">
                Refund Policy
              </Link>
            </div>
            <div className="w-min text-center lg:text-end">
              <a
                href="https://www.flexxited.com"
                target="_blank"
                rel="noreferrer"
                className="py-2 px-4 text-white text-sm font-normal inline-block hover:underline whitespace-nowrap"
              >
                Designed & developed by flexxited
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
